import React, { useEffect, useState } from "react";
import IlifestyleService from "../../../service/ilifestyle/ilifestyle";
import Table from "react-bootstrap/Table";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
//service
import AppInfoservice from "../../../service/common/Appinfo";

//style
import { Row, Col } from "react-bootstrap";
import { CurrencyDecimalFormat } from "../../helper";
export class ComponentToPrint extends React.PureComponent {
  constructor(props) {
    super(props);
    this.service = new IlifestyleService();
    console.log("pronhggggh", props);
    const current = new Date();

    const date = `${current.getDate()}/${
      current.getMonth() + 1
    }/${current.getFullYear()} , ${current.getHours()}:${current.getMinutes()}`;
    // const time = current.getHours() + ':' + current.getMinutes();

    this.state = {
      earnings: {},
      loading: true,
      date: date,
    };
  }

  exportDatas(type) {
    let keys = this.props.data.filterValues
      .map((key, idx) => {
        return "categories[" + idx + "]=" + key.value;
      })
      .join("&");
    console.log("enterde===");

    console.log("selectedddtabbbb", this.props.data.selectedTab);
    if (this.props.data.selectedTab === "ilifeearning") {
      this.service
        .earnigsExport(
          this.props.data.startDate,
          this.props.data.endDate,
          keys,
          type
        )
        .then((res) => {
          if (res.status) {
            this.setState((prevState) => ({
              ...prevState,
              loading: false,
              earnings: res.data.table_data,
            }));
          } else {
            this.setState((prevState) => ({
              ...prevState,
              loading: true,
            }));
          }
        });
    } else {
      this.service
        .exportData(
          this.props.data.startDate,
          this.props.data.endDate,
          keys,
          type
        )
        .then((res) => {
          if (res.status) {
            this.setState((prevState) => ({
              ...prevState,
              loading: false,
              statement: res.data.table_data,
            }));
          } else {
            this.setState((prevState) => ({
              ...prevState,
              loading: true,
            }));
          }
        });
    }
  }

  componentDidUpdate(prevProps) {
    console.log("prevpropss", prevProps);
    if (
      this.props.data.filterValues != prevProps.data.filterValues ||
      this.props.data.startDate != prevProps.data.startDate ||
      this.props.data.endDate != prevProps.data.endDate ||
      this.props.data.selectedTab != prevProps.data.selectedTab
    ) {
      this.exportDatas("print");
    }
  }
  componentDidMount() {
    this.exportDatas("print");
  }

  render() {
    return (
      <div style={{ padding: 60 }}>
        <Row>
          <Col>{this.state.date}</Col>
          <Col>
            <h5 style={{ textAlign: "center" }}>
              {this.props.data.selectedTab === "ilifeearning"
                ? "Points Earned History"
                : "Points History"}
            </h5>
          </Col>
        </Row>

        <div ref={this.ref}>
          <Row style={{ marginBottom: 50 }}>
            <Col span={8}>
              <img
                src={this.props.company.logo}
                alt="Logo"
                style={{ width: "10%" }}
              />
              <div>COMPANY NAME : {this.props.company.comapny_name}</div>
              <div>COMPANY ADDRESS : {this.props.company.company_address}</div>
              <div>TELEPHONE : {this.props.company.phone}</div>
              <div>EMAIL : {this.props.company.email}</div>
            </Col>
          </Row>

          {!this.state.loading && (
            // && this.state.earnings.length > 0
            <Table striped hover>
              {this.props.data.selectedTab === "ilifeearning" ? (
                <>
                  <thead>
                    <tr>
                      <td>No</td>
                      <td>Transaction Date</td>
                      <th>Details</th>
                      <th>Points</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.earnings.map((obj, index) => {
                      console.log("printdataa", obj);
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            {/* {moment(obj.transaction_date).format(
                              "MM/DD/YYYY h:m:ss"
                            )} */}
                            {moment
                              .utc(obj.transaction_date)
                              .subtract(8, "hours")
                              .tz("Asia/Manila")
                              .format("MM/DD/YYYY h:mm:ss A")}
                          </td>
                          <td>{obj.details}</td>
                          <td>
                            {/* {(
                              parseFloat(obj.points) * this.props.Currency.value
                            ).toFixed(this.props.Currency.precision)} */}
                            {CurrencyDecimalFormat(
                              obj.points * this.props.Currency.value,
                              this.props.Currency.precision
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </>
              ) : this.props.data.selectedTab === "ilifehistory" ? (
                <>
                  <thead>
                    <tr>
                      <td>No</td>
                      <td>Transaction Date</td>
                      <th>Ref No</th>
                      <th>Details</th>
                      <th>Total Value</th>
                      <th>Total Points</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.statement.map((obj, index) => {
                      console.log("printdataa", obj);
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            {moment
                              .utc(obj.transaction_date)
                              .subtract(8, "hours")
                              .tz("Asia/Manila")
                              .format("MM/DD/YYYY h:mm:ss A")}
                          </td>
                          <td>{obj.ref_no}</td>
                          <td>{obj.details}</td>
                          <td>
                            {(
                              parseFloat(obj.total_value) *
                              this.props.Currency.value
                            ).toFixed(this.props.Currency.precision)}
                          </td>
                          <td>
                            {(
                              parseFloat(obj.total_points) *
                              this.props.Currency.value
                            ).toFixed(this.props.Currency.precision)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </>
              ) : (
                ""
              )}
            </Table>
          )}
        </div>
      </div>
    );
  }
}

const UserEarningsPrintView = React.forwardRef((props, ref) => {
  // console.log("print", props);
  const Currency = useSelector((state) => state.curr);
  const { t } = useTranslation();

  const [companyDetails, setCompanyDetails] = useState({});

  const service = new AppInfoservice();

  useEffect(() => {
    service.Appinfo().then((res) => {
      if (res.status) {
        setCompanyDetails((prevState) => ({
          ...prevState,
          exportData: res.data.company_info.login_logo,
          comapny_name: res.data.company_info.company_name,
          company_address: res.data.company_info.company_address,
          phone: res.data.company_info.phone,
          email: res.data.company_info.email,
        }));
      }
    });
  }, []);
  return (
    <ComponentToPrint
      ref={ref}
      data={props}
      company={companyDetails}
      Currency={Currency}
      t={t}
    />
  );
});
export default UserEarningsPrintView;
